// TODO: Add unit tests
export const getFormattedTime = (date?: string) => {
  const options = {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
  };
  const now: Date = date ? new Date(date) : new Date();
  //@ts-ignore
  return now.toLocaleString('en-US', options).replace(/, /g, ' ');
};

// TODO: Add unit tests
export const toUpperFirstLetter = (text: string): string => {
  if (!text) {
    return '';
  }

  return text
    .split(' ')
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
};

export const getPageHeight = (doc: any): number => doc.internal.pageSize.getHeight();
export const getPageWidth = (doc: any): number => doc.internal.pageSize.getWidth();
export const getCenterXPosition = (doc: any): number => getPageWidth(doc) / 2;
export const getPageCount = (doc: any): number => doc.internal.getNumberOfPages();

export const addSpace = (times: number): string => (times === 1 ? ' ' : ' '.repeat(times));
